<template>
  <div>
    <p class="title">{{ title }}</p>
    <img
      v-for="i in icons"
      :key="i"
      :src="require('@/assets/icons/' + i)"
      @click="
        selected = i;
        $emit('select', i);
      "
      :class="selected === i ? 'selected' : null"
    />
  </div>
</template>

<script>
const iconList = require("@/assets/icons/iconlist");
export default {
  name: "IconPicker",
  props: {
    title: { default: "Kies een icoon (optioneel)" },
    icons: {
      default: () => iconList
    }
  },
  data() {
    return {
      selected: "trophy-blue.svg"
    };
  }
};
</script>

<style lang="scss" scoped>
div {
  text-align: left;
  margin: 0 32px;

  img {
    width: 2.4rem;
    height: 2.4rem;
    border-radius: 0;
    box-sizing: border-box;

    &.selected {
      border-radius: 50%;
      background-color: #e6e6e6;
    }
  }

  p {
    margin-bottom: 8px;
  }
}
</style>
